import React from 'react';
import { Box, Container, Flex, Heading, Icon, Text, VStack } from '@chakra-ui/react';
import { InfoIcon } from 'lucide-react';
export function Disclaimer() {
  return <Box as="section" id="informacion-importante" bg="plum.900" borderTop="1px solid" borderColor="whiteAlpha.200" py={{
    base: 10,
    md: 14
  }} data-id="element-54" data-mp="3cr7ncs3dkhvc">
      <Container maxW="66rem" px={{
      base: 4,
      md: 6
    }} data-id="element-55" data-mp="32xgz9ob5u9g6">
        <Box bg="whiteAlpha.50" border="1px solid" borderColor="whiteAlpha.200" borderLeft="4px solid" borderLeftColor="gold.400" borderRadius="lg" p={{
        base: 6,
        md: 8
      }} data-id="element-56" data-mp="3qm0762qask7q">
          <Flex align="center" gap={3} mb={4} data-id="element-57" data-mp="3gtb8y9jrd2uc">
            <Icon as={InfoIcon} boxSize="1.25rem" color="gold.300" aria-hidden="true" data-id="element-58" data-mp="3lt737h2nlfwp" />
            <Heading as="h2" fontSize={{
            base: 'lg',
            md: '1.5rem'
          }} color="cream.50" data-id="element-59" data-mp="de6vs9ur760y">
              Información importante
            </Heading>
          </Flex>
          <VStack align="flex-start" spacing={3} data-id="element-60" data-mp="i702h39s8ofo">
            <Text fontSize={{
            base: 'sm',
            md: 'md'
          }} color="plum.100" data-id="element-61" data-mp="f0n6uf7bt635">
              Los servicios ofrecidos son de carácter espiritual, recreativo y de entretenimiento. No
              garantizan resultados específicos y los resultados pueden variar de una persona a otra.
              Estos servicios no sustituyen atención médica, psicológica, legal o financiera.
            </Text>
            <Text fontSize={{
            base: 'sm',
            md: 'md'
          }} color="plum.100" data-id="element-62" data-mp="xpaact9utnem">
              Las consultas pueden realizarse de manera voluntaria y bajo responsabilidad del cliente.
            </Text>
          </VStack>
        </Box>
      </Container>
    </Box>;
}